/**
 * Format a number as currency with commas and 2 decimal places
 *
 * @param amount - The amount to format
 * @param currency - The currency symbol (default: '$')
 * @returns Formatted currency string
 */
export const formatCurrency = (
  amount: number | string,
  currency: string = '$',
): string => {
  // Convert string to number if necessary
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount
  // Return empty string for invalid numbers
  if (isNaN(numAmount)) {
    return ''
  }
  // Format with commas and 2 decimal places
  return `${currency}${numAmount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
}
/**
 * Format a date with time
 *
 * @param dateString - Date string to format
 * @param includeTime - Whether to include time (default: false)
 * @returns Formatted date string
 */
export const formatDateTime = (
  dateString: string | Date,
  includeTime: boolean = false,
): string => {
  if (!dateString) return ''
  const date =
    typeof dateString === 'string' ? new Date(dateString) : dateString
  // Check if date is valid
  if (isNaN(date.getTime())) {
    return ''
  }
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }
  if (includeTime) {
    options.hour = '2-digit'
    options.minute = '2-digit'
    options.second = '2-digit'
    options.hour12 = true
  }
  return date.toLocaleString('en-US', options)
}
